import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachenetbeansideComponent } from './simple-icons-apachenetbeanside.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachenetbeansideComponent ],
    exports:      [ SimpleIconsApachenetbeansideComponent ],
    bootstrap:    []
})
export class SimpleIconsApachenetbeansideModule {}
